// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
export default {
  'key' : {}
};

import { default as data } from '../../package.json';

export const environment = {
    production: false,
    VERSION: data.version
};

export const appInsightsConfig = {
    instrumentationKey: '04b30350-2efc-42c7-bdad-77132e9c5ce8'
};

/*
 * In development mode, for easier debugging, you can ignore zone related error
 * stack frames such as `zone.run`/`zoneDelegate.invokeTask` by importing the
 * below file. Don't forget to comment it out in production mode
 * because it will have a performance impact when errors are thrown
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
